var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden"},_vm._l((_vm.modals),function(opts,index){return _c('div',{key:index},[_c(opts.component,_vm._b({ref:'modal_' + index,refInFor:true,tag:"component"},'component',opts.props,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }